// Components
import Button from "../../../components/Button/ButtonContainer";
import { CardContainer as Card } from "../../../components/Card/CardContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conference.module.scss";

export const ConferenceVideos = (props) => {
    const { addTag, conference, featuredVideos, history } = props;

    const hasVideos =
        featuredVideos && featuredVideos.length && featuredVideos[0] !== null;

    function handleSelect(video) {
        history.push({ pathname: `/videos/${video.id}`, state: { video } });
    }

    function onButtonClick() {
        addTag({ tag: conference.slug });
        history.push("/videos");
    }

    function renderVideos() {
        return featuredVideos
            .slice(0, 6)
            .map((video) => (
                <Card
                    data={video}
                    key={video?.id}
                    onClick={() => handleSelect(video)}
                />
            ));
    }

    return hasVideos ? (
        <Section classes={styles.videos}>
            <h1>videos</h1>
            <div className={styles.grid}>{renderVideos()}</div>
            <Button
                onClick={onButtonClick}
                text="more videos from this conference"
                theme="green"
            />
        </Section>
    ) : null;
};
